import { getItemsFromCollection } from "directus/src/operations";

export async function fetchSurveysJCAverage({ employeeId, tagId }) {
    try {
        const query = {
            fields: [
                "id",
                "job",
                "job.project.project_id",
                "job.project.name",
                "job.project.client.id",
                "job.coordinator",
                "questions.id",
                "questions.question",
                "questions.questions_id.question",
                "questions.question.question",
                "questions.question.category.name",
                "questions.response",
            ],
            filter: {
                job: {
                    coordinator: {
                        id: {
                            _eq: employeeId,
                        },
                    },
                    ...(tagId
                        ? {
                            project: {
                                tags: {
                                    tag: {
                                        _eq: tagId,
                                    },
                                },
                            },
                        }
                        : {}),
                },
                status: {
                    _eq: "submitted",
                },
            },
        };
        const response = await getItemsFromCollection("surveys", query);

        // Simply return the array of surveys
        return response;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export async function fetchSurveysAMAverage({ employeeId, tagId }) {
    try {
        const query = {
            fields: [
                "id",
                "job",
                "job.project.project_id",
                "job.project.name",
                "job.project.client.id",
                "job.project.account_manager",
                "questions.id",
                "questions.question",
                "questions.questions_id.question",
                "questions.question.question",
                "questions.question.category.name",
                "questions.response",
            ],
            filter: {
                job: {
                    project: {
                        account_manager: {
                            id: {
                                _eq: employeeId,
                            },
                        },
                        ...(tagId
                            ? {
                                tags: {
                                    tag: {
                                        _eq: tagId,
                                    },
                                },
                            }
                            : {}),
                    },
                },
                status: {
                    _eq: "submitted",
                },
            },
        };
        const response = await getItemsFromCollection("surveys", query);

        // Simply return the array of surveys
        return response;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

